import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo.js';

const Login = () => {
  const { t } = useTranslation();
  return (
    <main className="container mx-auto px-4 py-8">
      <Seo path="/login" title={t('login.seo.title')} description={t('login.seo.description')} />
      <h1 className="text-3xl font-bold mb-4">{t('login.title')}</h1>
      <Authenticator />
    </main>
  );
};

export default Login;
